import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

const SWITCH_SIZE = 1;

export const SwitchInput = styled.input`
  opacity: 0;
  pointer-events: none;
  position: absolute;
`;

export const SwitchIndicator = styled.span`
  background: ${colors.white};
  border-radius: 100%;
  display: inline-block;
  height: ${SWITCH_SIZE}rem;
  pointer-events: none;
  transform: translateX(0);
  transition: transform 100ms linear;
  width: ${SWITCH_SIZE}rem;
  z-index: 1;
`;

export const SwitchBackground = styled.span`
  background: ${colors.grayA};
  border-radius: ${SWITCH_SIZE}rem;
  bottom: 0;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: background 100ms linear;
`;

export const SwitchLabel = styled.label`
  cursor: pointer;
  display: inline-flex;
  padding: 2px;
  position: relative;
  width: ${SWITCH_SIZE * 2}rem;

  ${SwitchInput} {
    &:checked + ${SwitchBackground} {
      background: ${colors.blue7};
    }
    &:checked + ${SwitchBackground} + ${SwitchIndicator} {
      transform: translateX(100%);
    }
  }
`;
